import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { PaginationState } from '@tanstack/react-table';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import { QueryKey } from '@/Config/api/queryKey';
import { SourceUrlStatsDto } from '@/Domain/api/Analytics/dto/SourceUrl.dto';
import { DateRangeState } from '@/Domain/types/DateRange.types';

const toISODate = (date?: Date) => (date ? format(date, 'yyyy-MM-dd') : '');

export const useSourceUrls = (range: DateRangeState) => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });
  const start = toISODate(range.startDate);
  const end = toISODate(range.endDate);
  const rangeKey = `${start}:${end}`;
  const [paginationRangeKey, setPaginationRangeKey] = useState(rangeKey);
  const rangeChanged = paginationRangeKey !== rangeKey;
  const visiblePagination = rangeChanged ? { ...pagination, pageIndex: 0 } : pagination;

  useEffect(() => {
    if (!rangeChanged) return;
    setPagination((old) => (old.pageIndex === 0 ? old : { ...old, pageIndex: 0 }));
    setPaginationRangeKey(rangeKey);
  }, [rangeChanged, rangeKey]);

  const { data, isLoading, isError, isPlaceholderData } = useQuery<SourceUrlStatsDto>({
    queryKey: [
      QueryKey.analytics.sourceUrls,
      {
        start,
        end,
        pageIndex: visiblePagination.pageIndex,
      },
    ],
    placeholderData: keepPreviousData,
    staleTime: 0,
  });

  return {
    data,
    isLoading,
    isError,
    isPlaceholderData,
    pagination: visiblePagination,
    setPagination,
  };
};
